import { DOCUMENT } from '@angular/common';
import { Component, EventEmitter, Inject, Input, OnInit, Output, ViewChild } from '@angular/core';
import { Route, Router, RouterModule } from '@angular/router';
import { TranslateService } from '@ngx-translate/core';
import { Subject } from 'rxjs';
import { takeUntil } from 'rxjs/operators';
import { UIAction, UserSessionService } from '../app-user-session.service';
import { SelectizeComponent } from '../blocks';
import { ComponentType } from '../modules/component-type';
import { Module } from '../modules/module';
import { ModuleService } from '../modules/module.service';
import { FavoriteService } from '../security/favorite';
import { AuthService } from '../shared';

@Component({
  selector: 'laser-derma',
  templateUrl: './laser-derma-clinic.component.html',
  styleUrls: ['./laser-derma-clinic.component.css']
})
export class LaserDermaClinicComponent implements OnInit {
  dispalySetting: any;
  displayFlag: any;
  flagChangeSys: any;
  private ngUnsubscribe: Subject<void> = new Subject<void>();
  moduleList: Module[] = [];
  modulesSettings: any = {};
  rootModules: Module[] = [];
  subModules: Module[] = [];
  Links: Module[] = [];
  moduleLinks: Module[];
  moduleLinksFilter: Module[];
  previliges: any[];
  bufferedModuleLinks: any = {};
  selectedSubModule: Module = <Module>{};
  flagChangeModule: boolean = false
  selecetdLinkType: ComponentType = ComponentType.Favourits;
  userData: any = {}
  @Input() child_id: number;
  roles: any[] = [];
  generalizationAndAlerts: any[] = [];
  generalizationAndAlertsObj: any = {};
  selectedRoot: Module = <Module>{};
  @ViewChild('linksSelectize')
  linksSelectize: SelectizeComponent;
  branchNameAr: any;
  branchNameEn: any;
  linksTypesList: number[] = Object.keys(ComponentType).map(el => +el);
  @Output() LinkClick: EventEmitter<any> = new EventEmitter();
  currentLangFlag: string
  constructor(
    private _router: Router,
    private _authService: AuthService,
    private _moduleService: ModuleService,
    private _favouriteService: FavoriteService,
    private _USS: UserSessionService,
    private _userSessionService: UserSessionService,
    public translate: TranslateService,
    @Inject(DOCUMENT) private document
  ) {
    this.LTR();
    this.setRoutLink('/laser-derma/EmrDermaReception');
    // this.userData = this._userSessionService.getSessionKey('secUserMainData')
    this._userSessionService.getSessionKey$('GetUserData')
      .pipe(takeUntil(this.ngUnsubscribe))
      .subscribe((keys: any) => {
        if (keys.value) {
          this.userData = keys.value
        }
      });
  }
  LTR() {
    this.translate.use('en');
    this.currentLangFlag = 'En';
    this.document
      .getElementById('ltrCssFile')
      .setAttribute('href', 'assets/css/ltr.css');
  }

  ngOnInit() {


  }

  setRoutLink(routePath) {
    this.LTR();
    this._router.navigate([routePath, { mode: null }]).then(value => {
      this.LinkClick.emit(null);
    });
  }
  logout() {
    sessionStorage.setItem('forDebug', '0')
   // sessionStorage.setItem('forDev', '0')
    location.reload();
  }
}
